import React, { useState, useEffect } from 'react';
import './CountryCodeSelector.css';
import Input from '../Input/Input';
import Modal from '../Modal/Modal';
import searchIcon from '../../assets/header/searchIcon.png';
import { countries } from '../../utils/countries';

const CountryCodeSelector = ({ selectedCode, onSelect, error }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCountries, setFilteredCountries] = useState(countries);

  useEffect(() => {
    const filtered = countries.filter(country => 
      country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      country.code.includes(searchTerm)
    );
    setFilteredCountries(filtered);
  }, [searchTerm]);

  const handleCountrySelect = (country) => {
    setSearchTerm('');
    onSelect(country.code);
    setIsModalOpen(false);
  };

  return (
    <div className="country-code-selector">
      <div className="code-input" onClick={() => setIsModalOpen(true)}>
        <Input
          type="text"
          value={selectedCode}
          placeholder="+0"
          readOnly
          error={error}
          required
        />
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={{ text: 'Select Country', highlight: 'Code' }}
        showConfirmButton={false}
        message={
          <div className="country-selector-content">
            <div className="country-search">
              <Input
                type="text"
                placeholder="Search country..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                icon={searchIcon}
              />
            </div>
            
            <div className="countries-list">
              {filteredCountries.length > 0 ? (
                filteredCountries.map((country) => (
                  <div
                    key={`${country.name}-${country.code}`}
                    className="country-item"
                    onClick={() => handleCountrySelect(country)}
                  >
                    <span className="country-flag">{country.flag}</span>
                    <span className="country-name">{country.name}</span>
                    <span className="country-code">{country.code}</span>
                  </div>
                ))
              ) : (
                <div className="no-results">No countries found</div>
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};

export default CountryCodeSelector;
